import * as ActionTypes from './actionTypes.js';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const fetchDevicesOrdersList = (params = {}) => apiActionCreator({
  'endpoint': `/devices/orders${getUrlParameters(params)}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_DEVICES_ORDERS_LIST,
    ActionTypes.FETCHED_DEVICES_ORDERS_LIST,
    [
      ActionTypes.FETCHED_DEVICES_ORDERS_LIST_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const updateDeviceOrder = (data = {}, filtersState) => (dispatch) =>
  dispatch(apiActionCreator({
    'endpoint': '/devices/orders',
    'authenticated': true,
    'types': [
      ActionTypes.UPDATING_DEVICE_ORDER,
      [
        ActionTypes.UPDATED_DEVICE_ORDER,
        () => {
          dispatch(fetchDevicesOrdersList(filtersState));
          MessageActions.addMessageBoxInfo('Orden actualizada correctamente');
        },
      ],
      [
        ActionTypes.UPDATED_DEVICE_ORDER_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'PUT',
    'contentType': 'application/json',
    'data': {...data},
  }));

export const downloadOrdersList = (params) =>
  apiActionCreator({
    'endpoint': `/devices/vehicles${getUrlParameters(params)}`,
    'authenticated': true,
    'types': [
      ActionTypes.DOWNLOADING_DEVICE_ORDERS_LIST,
      [
        (response) => {
          return {
            'type': ActionTypes.DOWNLOADED_DEVICE_ORDERS_LIST,
            'payload': response.data,
          };
        },
      ],
      [
        ActionTypes.DOWNLOADED_DEVICE_ORDERS_LIST_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const changeOrdersMarked = (orders) => ({
  'type': ActionTypes.CHANGE_ORDERS_MARKED,
  'payload': orders,
});

export const changeChassisMarked = (chassis) => ({
  'type': ActionTypes.CHANGE_CHASSIS_MARKED,
  'payload': chassis,
});

export const updateSatellitalDeviceOrder = (params, filterState) => (dispatch) =>
  dispatch(apiActionCreator({
    'endpoint': `/devices/vehicles${getUrlParameters(params)}`,
    'authenticated': true,
    'types': [
      ActionTypes.UPDATING_SATELLITAL_DEVICE_ORDER,
      [
        ActionTypes.UPDATED_SATELLITAL_DEVICE_ORDER,
        (response) => {
          dispatch(MessageActions.addMessageBoxInfo('Orden actualizada correctamente'));
          dispatch(fetchDevicesOrdersList(filterState));
          dispatch(changeChassisMarked([]));
          dispatch(changeOrdersMarked([]));
        },
      ],
      [
        ActionTypes.UPDATED_SATELLITAL_DEVICE_ORDER_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'PUT',
    'contentType': 'application/json',
  }));

export const generateAndInstallDeviceOrders = (data, filterState) => (dispatch) =>
  dispatch(apiActionCreator({
    'endpoint': '/devices/orders',
    'authenticated': true,
    'types': [
      ActionTypes.CREATING_SATELLITAL_DEVICE_ORDER,
      [
        ActionTypes.CREATED_SATELLITAL_DEVICE_ORDER,
        (response) => {
          dispatch(MessageActions.addMessageBoxInfo(
            `${response.ordersCreated.length} Ordenes creadas correctamente.\n${response.ordersCreated}`));
          dispatch(fetchDevicesOrdersList(filterState));
          dispatch(changeChassisMarked([]));
          dispatch(changeOrdersMarked([]));
        },
      ],
      [
        ActionTypes.CREATED_SATELLITAL_DEVICE_ORDER_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'data': data,
    'method': 'POST',
    'contentType': 'application/json',
  }));

export const restoreDevicesOrdersPage = () => ({
  'type': ActionTypes.RESTORE_DEVICES_ORDERS_PAGE,
});

export const cleanDevicesOrderList = () => ({
  'type': ActionTypes.CLEAN_DEVICES_ORDERS_LIST,
});

export const changeDevicesOrdersDate = (date) => ({
  'type': ActionTypes.CHANGE_DEVICES_ORDERS_DATE,
  'payload': date,
});

export const changeDevicesOrdersDateEnd = (date) => ({
  'type': ActionTypes.CHANGE_DEVICES_ORDERS_DATE_END,
  'payload': date,
});

export const changeDevicesOrdersPage = (page) => ({
  'type': ActionTypes.CHANGE_DEVICES_ORDERS_PAGE,
  'payload': page,
});

export const resizeDevicesOrdersPage = (size) => ({
  'type': ActionTypes.RESIZE_DEVICES_ORDERS_PAGE,
  'payload': size,
});

export const clearSatellitalDevice = () => ({
  'type': ActionTypes.CLEAR_SATELLITAL_DEVICE,
});
